import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	TranslatedString,
	Card
} from '@bosch/bt-ui';

import './SimDetail.css';
import withErrorHandler from '../../../components/ErrorHandler';

const SimDetail = (props) => {
	const {
		simDetails,
		deviceProviderName
	} = props;

	return (
		<Card
			htmlAttributes={{
				id: "sim-details",
				className: 'sim-details'
			}}
		>
			<h3>{deviceProviderName} Device Detail</h3>
			<div className="sim-details-container">
				<div className="sim-details"><TranslatedString stringId="Device Status :" /></div>
				<div className="sim-details-value">{simDetails?.deviceStatus ?? simDetails?.status}</div>
				<div className="sim-details">
					<TranslatedString stringId="IMEI :" />
				</div>
				<div className="sim-details-value">{simDetails?.imei}</div>
				<div className="sim-details">
					<TranslatedString stringId="IPAddress :" />
				</div>
				<div className="sim-details-value">{simDetails?.ipAddress}</div>
				<div className="sim-details">
					<TranslatedString stringId="Phone Number :" />
				</div>
				<div className="sim-details-value">{simDetails?.phoneNumber}</div>
				<div className="sim-details">
					<TranslatedString stringId="Online Status :" />
				</div>
				<div className="sim-details-value">{simDetails?.onlineStatus}</div>
				{deviceProviderName ==='Verizon' && (
					<>
					<div className="sim-details">
						<TranslatedString stringId="Account Number :" />
					</div>
					<div className="sim-details-value">{simDetails?.accountNumber}</div>
					<div className="sim-details">
						<TranslatedString stringId="Description :" />
					</div>
					<div className="sim-details-value">{simDetails?.description}</div>
					</>
				)}
				{deviceProviderName ==='MobileBroker' && (
					<>
					<div className="sim-details">
						<TranslatedString stringId="Real IP :" />
					</div>
					<div className="sim-details-value">{simDetails?.realIP}</div>
					<div className="sim-details">
						<TranslatedString stringId="NAT IP :" />
					</div>
					<div className="sim-details-value">{simDetails?.natIP}</div>
					<div className="sim-details">
						<TranslatedString stringId="Reference Number :" />
					</div>
					<div className="sim-details-value" id="sim-details-referenceNumber-value">{simDetails?.referenceNumber}</div>
					<div className="sim-details">
						<TranslatedString stringId="Activated By :" />
					</div>
					<div className="sim-details-value" id="sim-details-activatedBy-value">{simDetails?.activatedBy}</div>
					</>
				)}
				{deviceProviderName ==='Connector' && (
					<>
					<div className="sim-details">
						<TranslatedString stringId="Real IP :" />
					</div>
					<div className="sim-details-value">{simDetails?.realIP}</div>
					<div className="sim-details">
						<TranslatedString stringId="NAT IP :" />
					</div>
					<div className="sim-details-value">{simDetails?.natIP}</div>
					<div className="sim-details">
						<TranslatedString stringId="SAP Company ID :" />
					</div>
					<div className="sim-details-value">{simDetails?.sapCustomerId}</div>
					<div className="sim-details">
						<TranslatedString stringId="Company Name :" />
					</div>
					<div className="sim-details-value">{simDetails?.companyName}</div>
					</>
				)}
			</div>
		</Card>
	);
};

export default withErrorHandler(React.memo(SimDetail));